
import SwiperInit from './swiperInit'
document.addEventListener('DOMContentLoaded', () => {
  const phoneNumberSwiper = document.querySelectorAll('.phonenumber-swiper')
  const phoneSwiper = new SwiperInit({
    selector: phoneNumberSwiper,
    spaceBetween: 20,
    slidesPerView: 1,
    navigation: {
      nextEl: '.phone-nav-next',
      prevEl: '.phone-nav-prev',
    },
  }) 
})
